import { useQuery, UseQueryOptions } from 'react-query';

import { Deal, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDealQuery(
	guid: Guid | undefined,
	options?: Omit<UseQueryOptions<Deal, unknown, Deal, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Deal(guid),
		() => AxiosUtils.getResponseData<Deal>(api.get(CerebroApiEndpoints.Deals(guid))),
		options
	);
}
